import React, { useState } from 'react';
import { auth, googleProvider } from '../../firebase';
import { signInWithPopup } from 'firebase/auth';

export default function GoogleSignInButton({ onComplete }) {
  const [loading, setLoading] = useState(false);

  const handleGoogleSignIn = async () => {
    if (loading) return;
    setLoading(true);

    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      if (!user) throw new Error('Google Sign-in failed.');

      const token = await user.getIdToken(true); // 🔒 force token refresh

      // ✅ Pass to parent for conditional redirect
      onComplete(user.uid, user.email, true);
    } catch (err) {
      if (
        err.code === 'auth/cancelled-popup-request' ||
        err.code === 'auth/popup-closed-by-user'
      ) {
        console.warn('Popup was closed.');
      } else if (err.code === 'auth/popup-blocked') {
        alert('Popup blocked. Please enable popups for this site in your browser settings.');
      } else {
        console.error('Google Sign-In Error:', err.message);
        alert(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleGoogleSignIn}
      disabled={loading}
      className={`w-full px-4 py-2 rounded ${loading ? 'bg-gray-400' : 'bg-red-500 text-white'}`}
    >
      {loading ? 'Signing in...' : 'Continue with Google'}
    </button>
  );
}